import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class NavigationPopupLogoutComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('navigation') declare navigationService: Service.Navigation;

	@action
	logout() {
		this.navigationService.logout();
	}
	<template>
		<div class="content">
			<CommonUiIconComponent @name="Clock" @size="2xl" />
			<h3>Your session has expired</h3>
			<p>You will be logged out.</p>
			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent @onTrigger={{this.logout}} @text="Okay" />
				</div>
			</div>
		</div>
	</template>
}
